<div id="topArchive" *ngIf="archivedProfiles?.length > 0">
  <div class="more-ai-matched-card" *ngIf="projectDetails?.archivereevaluationstatus == 'pending'" [class.blur-content]="blur">
    <p> <i class="fa-solid fa-arrows-rotate"></i><span class="font-weight-500">Autopilot<sup style="top: -1px !important;"><span>AI</span></sup> Evaluation Criteria updated.</span> Click ‘Re-evaluate’ to apply updated Autopilot<sup><span>AI</span></sup> Evaluation criteria</p>
    <button data-testid="auto-app-ai-sourcing-archive-button-1" class="btn-get-more-candidate active"
      (click)="reEvaluateCriteria()">Re-evaluate</button>
  </div>
</div>
  <div class="more-ai-matched-card" *ngIf="projectDetails?.archivereevaluationstatus == 'started'" [class.blur-content]="blur">
    <p> <i class="fa-solid fa-circle-notch"></i><span class="font-weight-500">Autopilot<sup style="top: -1px!important;"><span>AI</span></sup> Re-evaluation in progress.</span> You'll receive an email once complete</p>
    <button data-testid="auto-app-ai-sourcing-archive-button-2" class="btn-get-more-candidate"
      >Re-evaluate</button>
  </div>

<div class="wccard d-flex flex-column justify-content-center align-items-center"
  *ngIf="archivedProfiles?.length == 0 && !showLoaderbeforeDataLoad && !doNotshowArchivePage" style="height: 470px;">
  <div class="text-center">
    <p class="f-14 font-weight-500 mb-0 text-center">No archived candidates yet.</p>
    <p class="f-14 font-weight-500 text-9696 text-center mt-1">Archived profiles from <b>To Review</b> will be shown here.</p>
    <img src="../../../assets/ai-sourcing/archive-candidate.gif" alt="img-fluid" class="img-config">
  </div>
</div>

<app-blurbackdrop *ngIf="(projectDetails?.status == 'inactive' || reviewpageAccessBlocked)"></app-blurbackdrop>

<div *ngIf="archivedProfiles?.length > 0 && !showLoaderbeforeDataLoad" >
  <div *ngFor="let candidate of archivedProfiles; let i = index">
    <app-ai-sourcing-profile-card [data]="candidate"  [selectedCandididate]="selectedCandididate" [index]="i" (childEvents)="eventHandler($event)"
      [calledfrompage]="'archivepage'">
      <div talentPoolBulkGrab>
        <label class="wc-checkbox mr-3">
          <input data-testid="auto-app-ai-sourcing-archive-input-1" [checked]="candidate.selected" [(ngModel)]="candidate.selected"
            (change)="selectCandidate($event, candidate)" type="checkbox" id="mycheck" name="mycheck">
          <i class="fas fa-check"></i>
        </label>
      </div>
    </app-ai-sourcing-profile-card>
  </div>
</div>


<div class="h-50 justify-content-center d-flex flex-column" *ngIf="showLoaderbeforeDataLoad">
  <div *ngFor="let i of [1,2,3,4,5]">
    <app-ai-sourcing-profile-skeleton></app-ai-sourcing-profile-skeleton>
  </div>
</div>

<div class="new-card d-flex justify-content-center wccard align-items-center" *ngIf="archivedProfiles?.length > 0">
  <ngb-pagination [collectionSize]="totalCandidatesCount" [maxSize]="5" [pageSize]="20" [rotate]="true"
    (pageChange)="setPage($event)" [(page)]="currentPage">
    <ng-template ngbPaginationPrevious> <span>
    </span>
    </ng-template>
    <ng-template ngbPaginationNext>
      <span *ngIf="archivedProfiles?.length">Next</span> </ng-template>
  </ngb-pagination>
</div>
<div class="row justify-content-start">
  <div id="overlay" (click)="closeNav()">
  </div>
</div>

<div id="quickView">
  <div class="pr-3" *ngIf="showCandidate">
    <app-person-search-candidate-slider [data]="currentCandidate" [viewMoreSkills]="viewMoreSkills"
      [highlightkeywords]="highlightkeywords" [tabType]="tabType" (childEvents)="eventHandler($event)"
      (handleOutputEvent)="eventHandler($event)" [currentIndex]="currentIndex" [calledfrompage]="'archivepage'">
      <div shortlist class="pb-2">
        <div class="d-flex">
          <button data-testid="auto-app-ai-sourcing-archive-button-3" class="ml-2 btn-trms-regular px-0" style="width: 50%;"
            (click)="changeCandidateStatus(currentCandidate,'shortlisted')">
            <i class="fa-solid fa-user-plus mr-1"></i>Shortlist
          </button>


        </div>
      </div>

    </app-person-search-candidate-slider>
  </div>
</div>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
